import { render } from "./onboarding-email-step-2-verify.vue?vue&type=template&id=16f809b7"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__